import { ArrowRight, LoaderCircle } from 'lucide-react'
import type { ButtonHTMLAttributes } from 'react'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { text?: string; loading?: boolean }

export function FlowButton({ text = 'Continue', loading = false, className = '', disabled, ...props }: Props) {
  return (
    <button aria-label={props['aria-label'] ?? text} disabled={disabled || loading} className={`flow-button group ${className}`} {...props}>
      {loading ? <LoaderCircle className="left-icon animate-spin" /> : <ArrowRight className="left-icon" />}
      <span>{loading ? 'Working…' : text}</span><span className="button-fill" /><ArrowRight className="right-icon" />
    </button>
  )
}
